import DataLayer from './DataLayer';

const dataLayer = new DataLayer();
export default dataLayer;
